export default __webpack_public_path__ + "static/bicentennial-logo-horizontal-dd58ae4455db6a22eebebc3585b304f1.png";